import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { LinkOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { OPERATION, ROUTES } from '@/constants';
import useQueryParamsContext from '@/contexts/query-params/useQueryParamsContext';

export default function TimeSheetButton({ employeeId, company }) {
  const { t } = useTranslation(['menus']);
  const navigate = useNavigate();

  const { queryParams } = useQueryParamsContext();

  const handleRedirect = () => {
    // Use queryParams.company first, fallback to company prop from employee data
    const companyId = queryParams.company || (typeof company === 'string' ? company : company?._id);

    if (!companyId) {
      console.warn(
        'Warning: Potential issue detected with the query parameters dataset.',
        queryParams
      );

      console.error(
        'Please contact the development team to resolve this issue.'
      );
      return;
    }

    navigate(
      `${ROUTES.admin}/${ROUTES.time_sheet}/${OPERATION.edit}/${employeeId}?offset=${1}&limit=${10}&company=${companyId}&month=${new Date().getMonth() + 1}&year=${new Date().getFullYear()}&route=general-data`
    );
  };

  return (
    <Button
      className="btn-secondary justify-start whitespace-nowrap !rounded-[50px]"
      icon={<LinkOutlined className="text-base" />}
      onClick={handleRedirect}
    >
      <strong>{t('goToTimesheet', { ns: 'menus' })}</strong>
    </Button>
  );
}
